export const statesAndCities = {
  Dubai: [
    "Academic City",
    "Al Awir",
    "Al Barari",
    "Al Barsha",
    "Al Fahidi",
    "Al Furjan",
    "Al Garhoud",
    "Al Yufrah 1",
    "Al Jaddaf",
    "Al Karama",
    "Al Khawaneej",
    "Al Mankhool",
    "Al Mamzar",
    "Al Meraqqabat",
    "Al Mizhar",
    "Al Muteena",
    "Al Nahda",
    "Al Qudra",
    "Al Quoz",
    "Al Raffa",
    "Al Rashidiya",
    "Al Safa",
    "Al Satwa",
    "Al Sufouh",
    "Al Warqa",
    "Al Wasl",
    "Arabian Ranches",
    "Arabian Ranches 2",
    "Arabian Ranches 3",
    "Arjan",
    "Barsha Heights (Tecom)",
    "Bluewaters Island",
    "Discovery Gardens",
    "Dubai Creek Harbour",
    "Dubai Heritage Vision",
    "Business Bay",
    "City Walk",
    "Culture Village (Jadaf Waterfront)",
    "Damac Hills",
    "DAMAC Lagoons",
    "Deira",
    "Discovery Gardens",
    "Downtown Dubai",
    "Dubai Creek Harbour",
    "Dubai Design District (d3)",
    "Dubai Festival City",
    "Dubai Harbour",
    "Dubai Hills Estate",
    "Dubai Industrial City",
    "Dubai International Financial Centre (DIFC)",
    "Dubai Internet City",
    "Dubai Investment Park (DIP)",
    "Dubai Land",
    "Dubai Marina",
    "Dubai Maritime City",
    "Dubai Media City",
    "Dubai Production City (IMPZ)",
    "Dubai Silicon Oasis",
    "Dubai South (Dubai World Central)",
    "Dubai Sports City",
    "Emirates Hills",
    "Expo City Dubai",
    "Garden View Villas (Gardens)",
    "Green Community",
    "Hor Al Anz",
    "International City",
    "Jebel Ali",
    "Jebel Ali Free Zone (JAFZA)",
    "Jumeirah",
    "Jumeirah Bay Island",
    "Jumeirah Beach Residence (JBR)",
    "Jumeirah Golf Estates",
    "Jumeirah Islands",
    "Jumeirah Lakes Towers (JLT)",
    "Jumeirah Park",
    "Jumeirah Village Circle (JVC)",
    "Jumeirah Village Triangle (JVT)",
    "Khawaneej",
    "La Mer (Jumeirah 1 Waterfront)",
    "Layan",
    "Marsa Al Arab",
    "Meydan",
    "Mirdif",
    "Mohammed Bin Rashid City (MBR City)",
    "Motor City",
    "Mudon",
    "Muhaisnah",
    "Nad Al Hamar",
    "Nad Al Sheba",
    "Nad Shamma",
    "Oud Al Muteena",
    "Oud Metha",
    "Palm Jumeirah",
    "Pearl Jumeirah",
    "Port Rashid",
    "Port Saeed",
    "Ras Al Khor",
    "Remraam",
    "Serena",
    "Sheikh Zayed Road",
    "Silicon Oasis",
    "Sports City",
    "The Greens",
    "The Lakes",
    "The Meadows",
    "The Springs",
    "The Sustainable City",
    "The Views",
    "The Villa",
    "Town Square",
    "Trade Centre",
    "Umm Al Sheif",
    "Umm Ramool",
    "Umm Suqeim",
    "Victory Heights",
    "Warsan",
    "Wasl Gate",
    "World Islands",
    "Zabeel"
  ],
  "Abu Dhabi": [
    "AbuDhabi Gate City",
    "Airport Road",
    "Al Ain (Green City)",
    "Al Bateen",
    "Al Danah",
    "Al Dhafra Industrial Area",
    "Al Dhafrah",
    "Al Falah",
    "Al Gurm",
    "Al Hosn",
    "Al Khalidiyah",
    "Al Karama",
    "Al Karamah",
    "Al Maqtaa",
    "Al Manaseer",
    "Al Manhal",
    "Al Marina",
    "Al Maryah Island",
    "Al Mina",
    "Al Muntazah",
    "Al Mushrif",
    "Al Mushrif Village",
    "Al Nahyan",
    "Al Qurm",
    "Al Raha Beach",
    "Al Raha Gardens",
    "Al Reem Island",
    "Al Rowdah",
    "Al Seef Village",
    "Al Shamkha",
    "Al Shawamekh",
    "Al Wahda",
    "Al Zaab",
    "Al Zahiyah (Tourist Club Area)",
    "Al Zeina (Raha Beach)",
    "Al Muneera (Raha Beach)",
    "AL Bahia",
    "Bain Al Jessrain (Between Two Bridges)",
    "Baniyas",
    "Capital Centre",
    "Corniche Area",
    "Corniche Road",
    "Danet Abu Dhabi",
    "Electra Street (Zone 1)",
    "Hudayriat Island",
    "Hydra Village",
    "ICAD I, II, III (Industrial City of Abu Dhabi)",
    "Khalifa City",
    "Khalifa City A",
    "Khalifa City B",
    "Khor Al Maqta",
    "KIZAD (Khalifa Industrial Zone Abu Dhabi)",
    "Liwa Oasis",
    "Madinat Khalifa",
    "Madinat Zayed",
    "Marina Village",
    "Masdar City",
    "Mina Zayed",
    "Mohammed Bin Zayed City (MBZ)",
    "Mussafah",
    "Mussafah Industrial Area",
    "Rawdhat Abu Dhabi",
    "Ras Al Akhdar",
    "Reem Downtown",
    "Saadiyat Island",
    "Shakhbout City",
    "Shamkha South",
    "Shati Al Raha",
    "The Galleria",
    "Tourist Club Area (Al Zahiyah)",
    "Western Region (Al Dhafra)",
    "Yas Island",
    "Al Rahba",
    "Al Samha"
  ],
  "Ras Al Khaimah":[
    "Adhen",
    "Al Dhait",
    "Al Dhaya",
    "Al Ghail",
    "Al Ghayl",
    "Al Hamra Village",
    "Al Hamraniyah",
    "Al Jazeera Al Hamra",
    "Al Jazirah Al Hamra",
    "Al Khuzam",
    "Al Mairid",
    "Al Nakheel",
    "Al Oraibi",
    "Al Qusaidat",
    "Al Qurm",
    "Al Rams",
    "Al Riffa",
    "Al Seer",
    "Dafan Al Khor",
    "Dafan Al Nakheel",
    "Digdaga",
    "Ghalilah",
    "Jebel Jais",
    "Julphar",
    "Khatt",
    "Khuzam",
    "Masafi",
    "Mina Al Arab",
    "Sha’am",
    "Shamal Julphar",
    "Sidroh",
    "Wadi Asfai",
    "Wadi Bih",
    "Wadi Shah"
  ],
  Sharjah:[
    "Abu Shagara",
    "Al Abar",
    "Al Azra",
    "Al Barashi",
    "Al Bataeh",
    "Al Butina",
    "Al Dhaid",
    "Al Darari",
    "Al Falah",
    "Al Falaj",
    "Al Fayha",
    "Al Fisht",
    "Al Gharayen",
    "Al Gharb",
    "Al Ghafya",
    "Al Ghubaiba",
    "Al Goaz",
    "Al Heera",
    "Al Juraina",
    "Al Khan",
    "Al Khaledia",
    "Al Khatim",
    "Al Layyah",
    "Al Mahatta",
    "Al Majarrah",
    "Al Majaz",
    "Al Manakh",
    "Al Mareija",
    "Al Madam",
    "Al Mujarrah",
    "Al Musalla",
    "Al Nahda",
    "Al Nabba",
    "Al Nud",
    "Al Qadisiya",
    "Al Qasba",
    "Al Qasimiya",
    "Al Qulayaa",
    "Al Rahmaniya",
    "Al Rifah",
    "Al Rolla",
    "Al Sabkha",
    "Al Saja'a",
    "Al Sajaa",
    "Al Seef",
    "Al Sharq",
    "Al Soor",
    "Al Suyoh",
    "Al Sweihat",
    "Al Tai",
    "Al Wahda",
    "Al Yarmook",
    "Al Yarmouk",
    "Al Zubair",
    "Al Zubair Orchards",
    "Bu Tina",
    "Dasman",
    "Halwan Suburb",
    "Hoshi",
    "Industrial Area",
    "Kalba",
    "Khor Fakkan",
    "Maysaloon",
    "Mleiha",
    "Muwaileh",
    "Muwaileh Commercial",
    "Muwafjah",
    "Samnan",
    "Sharjah Industrial Area",
    "Sharjah Waterfront City",
    "Sharqan",
    "Soor Kalba",
    "University City",
    "Wasit"
  ],

  Fujairah: [
    "Al Aqah",
    "Al Badiyah",
    "Al Buthna",
    "Al Faseel",
    "Al Ghurfah",
    "Al Hail",
    "Al Hilal",
    "Al Mahatta",
    "Al Nakheel",
    "Al Owaid",
    "Al Qurayyah",
    "Al Rifaa",
    "Al Rughaylat",
    "Al Sharia",
    "Al Taween",
    "Dadna",
    "Dhadnah",
    "Dibba Al Fujairah",
    "Masafi",
    "Merashid",
    "Mirbah",
    "Murabah",
    "Qidfa",
    "Sakamkam",
    "Wadi Wurayah",
    "Zubarah"
  ],
  Ajman: [
    "Ajman Corniche",
    "Ajman Free Zone",
    "Ajman Industrial Area",
    "Ajman Marina",
    "Ajman Uptown",
    "Al Amerah",
    "Al Bahya",
    "Al Bustan",
    "Al Hamidiya",
    "Al Hamriya",
    "Al Heliow",
    "Al Helio",
    "Al Jurf",
    "Al Jurf Industrial",
    "Al Mowaihat",
    "Al Muntazi",
    "Al Nakhil",
    "Al Nuaimiya",
    "Al Owan",
    "Al Raqaib",
    "Al Rashidiya",
    "Al Rashidiya 2",
    "Al Rashidiya 3",
    "Al Rawda",
    "Al Rumailah",
    "Al Sawan",
    "Al Tallah",
    "Al Yasmeen",
    "Al Zahra",
    "Al Zahya",
    "Emirates City",
    "Garden City",
    "Mushairif",
    "Mushairef",
    "Nuaimiya Towers",
    "Sheikh Khalifa Bin Zayed City"
  ],
  "Umm Al Quwain":[
    "Al Aahad",
    "Al Abraq",
    "Al Dar Al Baida",
    "Al Dhaidah",
    "Al Haditha",
    "Al Hamriyah",
    "Al Humrah",
    "Al Khuraija",
    "Al Khor",
    "Al Labsa",
    "Al Maarid",
    "Al Madar",
    "Al Maidan",
    "Al Mareija",
    "Al Neefah",
    "Al Raas",
    "Al Raudah",
    "Al Raudat",
    "Al Rifaah",
    "Al Riqa",
    "Al Riqqah",
    "Al Salamah",
    "Al Salam City",
    "Al Shabiyah",
    "Al Shuweihat",
    "Al Siniyah Island",
    "Al Surrah",
    "Al Ramlah",
    "Al Rashidiyah",
    "Falaj Al Mualla",
    "Khor Al Beidah",
    "Old Town (Al Dour)"
  ],
};
